module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_kurva_2.a3cea036.jpg";